import React from 'react';
import { useIntl } from 'react-intl';
import { faLinkSlash } from '@fortawesome/pro-light-svg-icons/faLinkSlash';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { TypedMemo } from '../../../../../common/types';
import { ConfirmDialog } from '../../../../../common/views/modals/confirmDialog/ConfirmDialog';
import { ConfirmDialogIconMark } from '../../../../../common/views/modals/confirmDialog/ConfirmDialogMark';
import { songPageMessages } from '../songPageMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from '../SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongRemoveDialogProps {
  isOpen: boolean;
  title: string;
  isClaimed: boolean;
  isBusy: boolean;
  error?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/** "Remove <title> from the catalog?" (design e4): what goes and what stays. A claimed row un-claims. */
const SongRemoveDialogComponent: React.FC<SongRemoveDialogProps> = ({
  isOpen,
  title,
  isClaimed,
  isBusy,
  error,
  onConfirm,
  onCancel,
}) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="danger"
      mark={<ConfirmDialogIconMark tone="danger" icon={isClaimed ? faLinkSlash : faTrash} />}
      title={intl.formatMessage(isClaimed ? songPageMessages.unclaimDialogTitle : songPageMessages.removeDialogTitle, {
        title,
      })}
      description={
        isClaimed
          ? intl.formatMessage(songPageMessages.unclaimDialogBody, { title })
          : intl.formatMessage(songPageMessages.removeDialogLead)
      }
      confirmLabel={intl.formatMessage(isClaimed ? songPageMessages.unclaimButton : songPageMessages.removeConfirm, {
        title,
      })}
      isBusy={isBusy}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
      testId="song-page-remove-dialog"
    >
      {!isClaimed && (
        <>
          <ul className={styles.removeList}>
            <li>{intl.formatMessage(songPageMessages.removeGoesSong)}</li>
            <li>{intl.formatMessage(songPageMessages.removeGoesKit)}</li>
            <li>{intl.formatMessage(songPageMessages.removeGoesStem)}</li>
          </ul>
          <p className={styles.help}>{intl.formatMessage(songPageMessages.removeStays)}</p>
        </>
      )}
    </ConfirmDialog>
  );
};

export const SongRemoveDialog = TypedMemo(SongRemoveDialogComponent);
